import Component from '../core/Component';

export default class Navigation extends Component {
    prepare() {
        this.button = document.querySelector('.topbar__toggle');
        this.button.addEventListener('click',::this.handleClick)
    }

    handleClick(e) {
        e.preventDefault();

        this.button.classList.toggle("is-active");
        document.querySelector(".navigation").classList.toggle("is-active");
    }
}


// WEBPACK FOOTER //
// ./components/Navigation.js